"use client";

import { useState, useRef, forwardRef } from "react";
import styles from "./styles.module.css";

const Checkbox = forwardRef(
  (
    {
      id,
      className = "",
      checked = false,
      defaultChecked,
      disabled = false,
      required = false,
      name,
      value,
      size = "medium",
      onCheckedChange,
      ...props
    },
    ref
  ) => {
    const [isChecked, setIsChecked] = useState(defaultChecked || checked);
    const inputRef = useRef(null);

    // Handle controlled and uncontrolled components
    const handleCheckedState = () => {
      if (checked !== undefined) {
        return checked;
      }
      return isChecked;
    };

    const handleChange = (event) => {
      if (disabled) return;

      if (checked === undefined) {
        setIsChecked(!isChecked);
      }

      onCheckedChange && onCheckedChange(event.target.checked);
    };

    return (
      <div className={`${styles.checkboxContainer}`}>
        <div
          className={`${styles.checkboxWrapper} ${
            styles[`checkboxWrapper--${size}`]
          }`}
        >
          <input
            type="checkbox"
            id={id}
            ref={ref || inputRef}
            name={name}
            value={value}
            checked={handleCheckedState()}
            disabled={disabled}
            required={required}
            onChange={handleChange}
            className={styles.checkboxInput}
            {...props}
          />
          <div
            className={`
            ${styles.checkbox} 
             ${className}
            ${handleCheckedState() ? styles.checked : ""} 
            ${disabled ? styles.disabled : ""}
          `}
            aria-hidden="true"
          >
            {handleCheckedState() && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={styles.checkIcon}
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </div>
        </div>
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";

export { Checkbox };
